import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createUnidadeModel } from '../utils/unidadeUtils';

// idb store name
const storeName = 'unidades';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'unidade';
// const sqlUnidade = 13;

export const unidadeService = {
  getUnidades,
  getUnidadesAPI,
  getUnidade,
  addUnidade,
  addUnidades,
  updateUnidade,
  compareAndUpdateUnidades
};

function getUnidades() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBUnidades();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getUnidadesAPI();
  return getIndexedDBUnidades();
}

async function getUnidadesAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_unidade",
      "unidade",
      "qtde_unidade",
      "abreviacao"
    ],
    filtros: [
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const unidadesApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateUnidades(unidadesApi);
  await removeInexistentes(unidadesApi);
  return unidadesApi;
}

function getIndexedDBUnidades() {
  return idbService.getAll(storeName);
}

function getUnidade(id) {
  return idbService.getById(storeName, id);
}

async function compareAndUpdateUnidades(unidades) {
  if (unidades && unidades.length) {
    for (const unidade of unidades) {
      const savedUnidade = await getUnidade(unidade.id_unidade);
  
      if (!savedUnidade) {
        unidade.versao_imp = 1;
        await addUnidade(unidade);
      } else {
        unidade.versao_imp = savedUnidade.versao_imp ? savedUnidade.versao_imp + 1 : 1;
        await updateUnidade(unidade);
      }
    }
  } else {
    // Limpa os registros do store unidades
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(unidadesApi) {
  if (unidadesApi && unidadesApi.length) {
    const idsUnidadesApi = unidadesApi.map(unidadeApi => unidadeApi.id_unidade);
    const unidadesLocal = await idbService.getAll(storeName);
    const unidadesInexistentes = unidadesLocal.filter(unidadeLocal => !idsUnidadesApi.includes(unidadeLocal.id_unidade));
    if (unidadesInexistentes && unidadesInexistentes.length) {
      for (const unidade of unidadesInexistentes) {
        await idbService.deleteFromStore(storeName, unidade.id_unidade);
      }
    }
  } else {
    return;
  }
}

async function addUnidade(unidade) {
  // const parsedUnidade = createUnidadeModel(unidade);
  return idbService.addToStore(storeName, unidade);
}

async function addUnidades(unidades = []) {
  const parsedUnidades = unidades.map(unidade => createUnidadeModel(unidade));
  return idbService.addMultipleToStore(storeName, parsedUnidades);
}

async function updateUnidade(unidade) {
  const parsedUnidade = createUnidadeModel(unidade);
  await idbService.updateItem(storeName, parsedUnidade);
}